import instance from "@/store/api/instance";

export let CpDashReportDn = function (data) {
    return instance.post('/cpdash/code/sub/report/dn/read', data)
}

export let CpDashReportDnExport = function (data) {
    return instance.post('/cpdash/code/sub/report/dn/export', data)
}
